import { render, staticRenderFns } from "./MembersForm.vue?vue&type=template&id=bc4a53b4&scoped=true"
import script from "./MembersForm.vue?vue&type=script&lang=js"
export * from "./MembersForm.vue?vue&type=script&lang=js"
import style0 from "./MembersForm.vue?vue&type=style&index=0&id=bc4a53b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a53b4",
  null
  
)

export default component.exports